"use strict";

exports.__esModule = true;
exports["default"] = ControlTop;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ControlTop(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.474 12.545V30.43c0 .83.673 1.507 1.503 1.507a1.51 1.51 0 0 0 1.507-1.507V12.545l8.497 8.504c.59.587 1.537.587 2.124 0a1.501 1.501 0 0 0 0-2.127L17.039 7.848a1.538 1.538 0 0 0-.488-.316 1.397 1.397 0 0 0-.574-.121c-.201 0-.393.041-.581.121a1.619 1.619 0 0 0-.485.316L3.845 18.922a1.484 1.484 0 0 0 0 2.127 1.501 1.501 0 0 0 2.124 0l8.505-8.504zM4.891.063h22.214c.831 0 1.5.668 1.5 1.497 0 .824-.669 1.497-1.5 1.497H4.891c-.83 0-1.496-.673-1.496-1.497 0-.829.666-1.497 1.496-1.497z"
  }));
}